<div
  *ngIf="size === 'lg'"
  class="avatar-wrapper"
  ngbPopoverClass="popover-custom"
  placement="top"
  [ngbPopover]="title"
  triggers="mouseenter:mouseleave"
>
  <span class="circle-image-lg default-pointer" *ngIf="imageUrl && !imageLoadError">
    <img [src]="imageUrl" (error)="handleImageError()" />
  </span>
  <span class="circle-lg" *ngIf="!imageUrl || imageLoadError" [ngClass]="{ 'disabled-circle': disabled, 'default-pointer': !disabled }">{{
    nick?.toUpperCase()?.substring(2, 0)
  }}</span>
</div>
<div
  *ngIf="size !== 'lg'"
  class="avatar-wrapper"
  ngbPopoverClass="popover-custom"
  placement="top"
  [ngbPopover]="title"
  triggers="mouseenter:mouseleave"
>
  <span class="circle-image-md default-pointer" *ngIf="imageUrl && !imageLoadError">
    <img [src]="imageUrl" (error)="handleImageError()" />
  </span>
  <span class="circle-md" *ngIf="!imageUrl || imageLoadError" [ngClass]="{ 'disabled-circle': disabled, 'default-pointer': !disabled }">{{
    nick?.toUpperCase()?.substring(2, 0)
  }}</span>
</div>
